import axios from 'axios';
import config from '../Config';

const notificationsBase = () => `${config.REACT_APP_BASE_URL}/api/dashboard/v1/notifications`;
const userBase = () => `${config.REACT_APP_BASE_URL}/api/v1/user`;

// Centro con historial paginado (leídas y no leídas) + no leídas para el badge.
export const notificationsApi = {
  // Badge / reconciliación. Con sinceId devuelve lo creado después (id > since).
  unread: (sinceId) =>
    axios
      .get(`${notificationsBase()}/unread`, { params: sinceId ? { since_id: sinceId } : undefined })
      .then((r) => r.data),

  // Paginación: `cursor` es el meta.next_cursor de la página anterior, tal cual (opaco).
  // `beforeId` (meta.next_before_id) sigue andando por compatibilidad; si llegan los dos
  // manda `cursor`.
  history: ({ filter = 'all', limit = 20, cursor, beforeId } = {}) =>
    axios
      .get(notificationsBase(), {
        params: {
          filter,
          limit,
          ...(cursor ? { cursor } : beforeId ? { before_id: beforeId } : {}),
        },
      })
      .then((r) => r.data),

  // Una (id) o varias a la vez (arreglo de ids, máximo 50 por llamada).
  markAsViewed: (idOrIds) =>
    axios.post(
      `${notificationsBase()}/mark-as-viewed`,
      Array.isArray(idOrIds) ? { notification_ids: idOrIds } : { notification_id: idOrIds }
    ),

  // Con `upToId` solo marca hasta esa notificación en el orden del centro: lo que llegó
  // (o subió al tope) después de cargar la lista queda sin ver.
  markAllAsViewed: ({ upToId } = {}) =>
    axios.post(`${notificationsBase()}/mark-all-as-viewed`, upToId ? { up_to_id: upToId } : {}),
};

// Preferencias: push global + grupos in-app (chat siempre activo).
export const notificationPreferencesApi = {
  get: () => axios.get(`${userBase()}/notification-preferences`).then((r) => r.data.data),
  update: (payload) =>
    axios.post(`${userBase()}/notification-preferences`, payload).then((r) => r.data.data),
};
